<template>
  <AppButton
    :route="{
      name: 'memberships',
    }"
    class="memberships-button button-primary mx-auto mt-3 w-full"
    :title="$t('button.see.free_for_7_days')"
    :icon="Icons.ArrowRight"
  >
    {{ $t('button.see.free_for_7_days') }}
  </AppButton>
</template>
